import { Component, OnInit, QueryList, ViewChildren, ViewChild, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CreateTransmittalComponent } from '../transmittal-creation/transmittal-creation.component';
import { CommonService } from 'src/app/Service/Common.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { Align } from '@progress/kendo-angular-popup';
import { AttachmentsListComponent } from '../attachments-list/attachments-list.component';
import { TransmittalMsgService } from 'src/app/Service/transmittal/transmittal.service';
import { ITransmittalDetailsModel, ITransmittalDocumentDetails, ITransmittalDocumentInput, ITransmittalMailDetails, ITransmittalMsgInputModel, ITransmittalMsgReceiverInput } from 'src/app/ViewModel/TransmittalModel';
import { TransmittalTemplateComponent } from '../transmittal-template/transmittal-template.component';
import { MatTabChangeEvent } from '@angular/material/tabs';

import { formatDate } from '@angular/common';
import { TransmittalViewComponent } from '../transmittal-view/trasnsmittal-view.component';
import { EncryptDecryptService } from 'src/app/Service/encrypt-decrypt.service';
import { ITransmittalMemberModel } from 'src/app/ViewModel/TransmittalTemplateModel';
import { ProjectMemberModel } from 'src/app/ViewModel/ProjectMemberModel';
import { TransmittalService } from 'src/app/Service/transmittal-template/transmittal-template.service';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import * as _ from 'lodash';
import { DataBindingDirective } from '@progress/kendo-angular-grid';
import { Subscription, Observable, forkJoin } from 'rxjs';
import { saveAs } from 'file-saver';
import { StandardOutputModel } from 'src/app/ViewModel/StandardOutputModel';
import { FileService } from 'src/app/Service/file/file.service';
import { TransmittalEditComponent } from '../transmittal-edit/transmittal-edit.component';
@Component({
  selector: 'app-transmittal-list',
  templateUrl: './transmittal-list.component.html',
  styleUrls: ['./transmittal-list.component.css']
})
export class TransmittalListComponent implements OnInit, OnDestroy {
  @ViewChildren('divIcon') divIconHover!: QueryList<any>;
  @ViewChild(DataBindingDirective) dataBinding!: DataBindingDirective;
  public isSearch: boolean = false;
  enableFilter = false;
  enableFullscreen = false;
  pageSize = 15;
  LastViewingRecords = 30;
  LastViewingRecord: string = '30';
  noOfDays = [30, 60, 90, 'All'];
  public lastscrollLeft!: number;
  selectedIndex = 0;
  selectedRootIndex = 0;
  selectedTabIndex = 0;
  draft!: boolean;
  inbox!: boolean;
  landingall!: boolean;
  sent!: boolean;
  memberId: number = 0;
  projectId: number | null = null;
  groupId: number = 0;
  public gridData: ITransmittalDetailsModel[] = [];
  public data: any[] = [];
  public searchList: any[] = [];
  public allList: any[] = [];
  public buttonType = 'MyMessages';
  public viewTrasmittalTabs: TransmittalTemplateComponent[] = [];
  viewTransmittalData: TransmittalTemplateComponent | null | undefined;
  public viewData: any[] = [];
  public shareMsgList: any[] = [];
  public mailBoxType: any = null;
  IsShowCreateList = false;
  public anchorElementPopup: any;
  public anchorAlignCenter: Align = { horizontal: 'center', vertical: 'bottom' };
  public margin = { horizontal: -15, vertical: 10 };
  public projectName!: string;
  public datevalue = new Date(this.getDateFormat());
  private transmittalViewComponent!: TransmittalViewComponent;
  public membersList: ITransmittalMemberModel[] = [];
  UnsubscribeArray: Subscription[] = [];
  public mailReceiverDetails: any[] = [];
  public toMember: any[] = [];
  public ccMember: any[] = [];
  public fromMember: any[] = [];
  public MessageId: number | any = null;
  private _transmittalData!: TransmittalTemplateComponent | null;
  public isDTNReleased: boolean;

  @ViewChild('transmittalViewComponent') set content(content: TransmittalViewComponent) {
    if (content) { // initially setter gets called with undefined
      this.transmittalViewComponent = content;
    }
  }
  constructor(
    private dialog: MatDialog,
    private _transmittalService: TransmittalMsgService,
    public commonService: CommonService,
    private notificationService: NotificationService,
    private encryptDecryptService: EncryptDecryptService,
    private transmittalService: TransmittalService,
    private _fileService: FileService) {
    this.allData = this.allData.bind(this);
  }

  ngOnInit() {
    if (this.commonService.hasRequestedObject()) {
      setTimeout(() => {
        this.initialPageLoad();
      }, 2000);
    }
    else {
      this.initialPageLoad();
    }
  }

  initialPageLoad() {
    let currentProject = this.commonService.getCurrentProjectDetails();
    this.projectName = currentProject.projectCode + ' - ' + currentProject.projectDescription;
    this.memberId = this.commonService.getLoggedInUserId();
    this.projectId = currentProject.projectId;
    this.groupId = this.commonService.getLoggedInUserGroupId();
    this.loadGrid();
    this.getProjectMembers();
  }

  loadGrid() {
    let inputMsgId = null;
    if (this.commonService.hasRequestedObject()) {
      var requestedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('requestedObject')));
      inputMsgId = requestedObject['inputDocId'];
    }
    let _getTransmittalList = this._transmittalService.GetTransmittalList({ project_id: this.projectId }).subscribe((res: ITransmittalDetailsModel[]) => {
      res.forEach(x => {
        if(x.message_Id.toString() != x.message_Number)
          x.isDtnReleased = true;
        else
          x.isDtnReleased = false;
      })
      this.gridData = _.uniqBy(res, 'message_Number')
      this.setRedirectObjects();

      let x = this.gridData;
      x.map(y => {
        y.documentNo = res.filter(o => o.message_Number == y.message_Number).map(u => { return u.documentNo }).join(', ');
      });
    })
    this.UnsubscribeArray.push(_getTransmittalList)
  }

  setRedirectObjects() {
    if (this.gridData.length > 0 && this.commonService.hasRequestedObject()) {/*Mail Redirection*/
      var requestedObject = JSON.parse(this.encryptDecryptService.decrypt(this.commonService.getSessionStorageItem('requestedObject')));
      let inputMsgId = requestedObject['inputMsgId'];
      if (inputMsgId) {
        this.commonService.checkAndDeleteRequestedObject();
        let _data = this.gridData.filter(x => x.message_Id == inputMsgId);
        if (_data.length > 0) {
          this.viewTransmittalClick(_data[0]);
        }
        else {
          this.notificationService.showToast("You are not authorized to view the Message", "Warning");
        }
      }
    }
  }

  public advanceSearch() {
    this.searchList = [];
    this.isSearch = !this.isSearch;
  }

  createTransmittalClick() {
    const dialogRef = this.dialog.open(CreateTransmittalComponent, {
      panelClass: 'mat-dialog-primary',
      data: { inputType: 'createTransmittal', selectedList: [] },
      autoFocus: false
    });
   
  }

  toggleFilter() {
    this.enableFilter = !this.enableFilter;
  }

  toggleFullscreen() {
    this.enableFullscreen = !this.enableFullscreen;
  }

  closeAdvSearch(event: any) {
    this.searchList = event;
    this.isSearch = false;
    if (this.searchList.length == 0) {
      this.notificationService.showToast("Search returned no results", "Warning");
    }
  }

  onHover(event: Event): void {
    if ((event.target as HTMLElement).closest('div.k-grid-content')) {
      const newscrollLeft = (event.target as HTMLElement).closest('div.k-grid-content')?.scrollLeft;
      if (newscrollLeft && this.lastscrollLeft !== newscrollLeft) {
        for (let i = 0; i < this.divIconHover.length; i++) {
          this.divIconHover['_results'][i]['nativeElement']['style'].right = (0 - newscrollLeft) + 'px';
        }
        this.lastscrollLeft = newscrollLeft;
      }
    }
  }

  public onValChange(val: string) {
    this.searchList = [];
    //Reset the isselected flag as false
    this.data.forEach(x => x.isSelected = false);
    this.buttonType = val;
  }

  /**
   * Multiple select of listed messages
   * @param event
   *
   */
  onSelectionChange(event: Event | any): void {
    if (event['selectedRows'].length > 0) {
      event['selectedRows'].forEach((element: any) => {
        element.dataItem.isSelected = true;
      });
    }
    if (event['deselectedRows'].length > 0) {
      event['deselectedRows'].forEach((element: any) => {
        element.dataItem.isSelected = false;
      });
    }
  }

  viewAttachmentClick(data: ITransmittalDetailsModel) {
    let dialogRef = this.dialog.open(AttachmentsListComponent, {
      panelClass: ['mat-dialog-secondary', 'w80'],
      data: { messageId: data.message_Id },
    });
    dialogRef.afterClosed().subscribe((data: any) => {
      if (!!data) {
        this.getPopupviewTransmittalClick(data);
      }
    });
  }

  /**Lastviewrecords change */
  public lastviewingrecordsmethod(event: any) {
    if (event == "All") {
      this.LastViewingRecords = 0;
      this.LastViewingRecord = "All";
    }
    else {
      this.LastViewingRecords = event;
      this.LastViewingRecord = event;
    }
    this.enableFilter = false;
    this.dataBinding.filter = undefined;
  }

  getDateFormat() {
    let today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = today.toLocaleString('default', { month: 'short' })
    var yyyy = today.getFullYear();
    let today1 = dd + '-' + mm + '-' + yyyy;
    return today1;
  }

  viewTabClick(event: MatTabChangeEvent) {
    this.viewTransmittalData = null;
    if (this.selectedTabIndex != 0) {
      this.viewTransmittalData = this.viewTrasmittalTabs[this.selectedTabIndex - 1];
    }
  }

  public closeTabClick(tab: TransmittalTemplateComponent) {
    this.viewTrasmittalTabs.forEach((value, index) => {
      if (value.message_id == tab.message_id) this.viewTrasmittalTabs.splice(index, 1);
      this.gridData.map((gridVal)=>{ if(gridVal.message_Id==value.message_id)  gridVal.isSelected = null; })
    });
    if (this.viewTrasmittalTabs.length == 0) {
      this.selectedTabIndex = 0;
    }
  }

  viewTransmittalClick(data: ITransmittalDetailsModel) {
    let filteredTransmittals: TransmittalTemplateComponent[] = this.viewTrasmittalTabs.filter(x => x.message_id == data.message_Id);
    if (filteredTransmittals && filteredTransmittals.length == 0) {
      this.pushTransmittalTemplateModel(data);
    }
  }

  getPopupviewTransmittalClick(data: any) {
    let filertGridData = this.gridData.filter(element => element.message_Id == data.messageId)[0];
    this.viewTransmittalClick(filertGridData);
  }

  pushTransmittalTemplateModel(data: ITransmittalDetailsModel) {
    this.MessageId = data.message_Id;
    this.isDTNReleased = data.isDtnReleased;
    let fileInput_Communication = {
      projectId: data.project_Id,
      messageId: data.message_Id
    }

    let groupDetails: Observable<any> = this._transmittalService.GetTransmittalGroupMemberDetails(data.message_Id);
    let docDetails: Observable<any> = this._transmittalService.GetTransmittalDocumentDetails(data.message_Id);
    let receiverDetails: Observable<any> = this._transmittalService.GetTransmittalReceiverDetails(data.message_Id);
    let getTransmittalFiles = this._fileService.GetFiles({ libraryNumber: 4, value: JSON.stringify(fileInput_Communication) });
    let _transmittalDetails = forkJoin(groupDetails, docDetails, receiverDetails,getTransmittalFiles).subscribe((res: any[]) => {
      let receiverDetails: ITransmittalMsgReceiverInput = res[2];
      let docDetails: ITransmittalDocumentInput = res[1];
      let transDocDetails: ITransmittalDocumentDetails[] = [];
      this.mailReceiverDetails.push(receiverDetails);
      if (!!docDetails && !!docDetails.transmittalDocumentDetails) {
        transDocDetails = docDetails.transmittalDocumentDetails;
      }
      let to = receiverDetails.transmittalToDetails[0].member_Id;
      let toWithAddress: string = "";
      if (to) {
        let toMember = this.membersList.filter(x => x.memberId == to)
        if (toMember.length && toMember[0].address) {
          toWithAddress = toMember[0].memberName + '<br>' + toMember[0].address;
        }
        else if (toMember.length) {
          toWithAddress = toMember[0].memberName ? toMember[0].memberName : "";
        }
        else {
          toWithAddress = receiverDetails.transmittalToDetails[0].member_Name;
        }
      }
      else {
        toWithAddress = receiverDetails.transmittalToDetails.map(x => x.member_Name).join(',')
      }
      let transmittalTemplate: TransmittalTemplateComponent = {
        templateName: 'common',
        projName: this.projectName,
        edrcRef: data.message_Number,
        cusRef: data.cust_Ref_No,
        docDetails: transDocDetails,
        distributionDetails: res[0],
        subject: data.message_Subject,
        attention: receiverDetails.transmittalToDetails.map(x => x.member_Name).join(','),
        to: toWithAddress,
        date: formatDate(data.created_On, 'dd-MMM-yyyy', 'en-US'),
        message_No: data.message_Number,
        message_id: data.message_Id,
        cc: receiverDetails.transmittalCcDetails.map(x => x.member_Name).join(','),
        From: receiverDetails.transmittalFromDetails.map(x => x.member_Name).join(','),
        message_Note: data.message_Note,
        fileDetails: res[3].length > 0 ? res[3] : []
      }
      // attention: receiverDetails.transmittalCcDetails.map(x => x.member_Name).join(','),
      this.viewTrasmittalTabs.push(transmittalTemplate);
      this._transmittalData = null;
      this._transmittalData = transmittalTemplate;
      this.selectedTabIndex = 1;
    })
    this.UnsubscribeArray.push(_transmittalDetails)
  }

  viewTransmittalsClick() {
    this.gridData.forEach(element => {
      if (element.isSelected)
        this.viewTransmittalClick(element);
    });
  }

  exportToWord() {
    //To check and remove "Signed Copies" column from Work document
    let rootElement: HTMLElement | any = document.getElementById('TransmittalComponent')?.cloneNode(true) as HTMLCanvasElement;
    let documentGrid: HTMLElement = rootElement.children[0].children["documentGrid"];
    if (documentGrid) {
      let tHead: HTMLCollection = documentGrid.children[0].children[0].children;
      if (tHead && tHead.length > 1) {
        tHead[1].remove();
      }
      for (let i = 0; i < documentGrid.children[1].children.length; i++) {
        let tBody: HTMLCollection = documentGrid.children[1].children[i].children;
        if (tBody && tBody.length > 1) {
          tBody[1].remove();
        }
      }
    }
    let docName: string = this.viewTrasmittalTabs[this.selectedTabIndex - 1].message_No;
    var header = "<html xmlns:o='urn:schemas-microsoft-com:office:office' xmlns:w='urn:schemas-microsoft-com:office:word' xmlns='http://www.w3.org/TR/REC-html40'><head><meta charset='utf-8'><style>body {margin-top: 0px; margin-right: 0px; margin-bottom: 0px; margin-left: 0px; font-size:14.5px; font-family:'Arial Narrow';}</style><title>Export Word Document</title></head><br><body>";
    var footer = "</body></html>";
    var html = header + rootElement.innerHTML + footer;
    var blob = new Blob(['\ufeff', html], {
      type: 'application/msword'
    });
    // Specify link url
    var url = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(html);
    // Specify file name
    let filename = docName + '.doc';
    // Create download link element
    var downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    // if (navigator.msSaveOrOpenBlob) {
    //   navigator.msSaveOrOpenBlob(blob, filename);
    // } 
    if (blob) {
      saveAs(blob, filename);
      // return;
    }
    else {
      // Create a link to the file
      downloadLink.href = url;
      // Setting the file name
      downloadLink.download = filename;
      //triggering the function
      downloadLink.click();
    }
    document.body.removeChild(downloadLink);
  }

  async getProjectMembers() {
    let _getProjectMembers = this.transmittalService.getProjectMembers().subscribe(async (res: ProjectMemberModel[]) => {
      this.membersList = res.map(x => {
        let transmittalMember: ITransmittalMemberModel = {
          memberId: x.memberId,
          memberName: x.memberName,
          memberShortName: x.memberShortName,
          eMailId: x.eMailId,
          mobileNo: x.mobileNo,
          staffPSNo: x.staffPSNo,
          address: x.address
        };
        return transmittalMember;
      });
    });
    this.UnsubscribeArray.push(_getProjectMembers)
  }

  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: this.gridData
    };
    return result;
  }

  public HelpUrlClick() {
    let x = JSON.parse(this.commonService.getSessionStorageItem("Menu"))
    let url = x.filter((y: { menuDesc: string; }) => y.menuDesc == "Transmittal")[0].helpUrl
    if (url) {
      window.open(url);
    }
  }

  getMailIDList(input: any) {
    let globArr: { memberId: number; }[] = [];
    let arr = input;
    let result = arr.split(',');
    result.forEach(function (obj: string) {
      let memberObj = { memberId: parseInt(obj, 10) }
      globArr.push(memberObj);
    });
    return globArr;
  }

  isNull(data: string) {
    return data != null ? data : '';
  }

  closeDialog() {
    this.selectedTabIndex = 0;
  }

  async sendMail(is_Send_Mail: boolean) {
    if (is_Send_Mail) {
      let toMemberIds = this.mailReceiverDetails[0].transmittalToDetails.map((x: { member_Id: any; }) => x.member_Id).join(',')
      let ccMemberIds = this.mailReceiverDetails[0].transmittalCcDetails.map((x: { member_Id: any; }) => x.member_Id).join(',')
      let fromMemberIds = this.mailReceiverDetails[0].transmittalFromDetails.map((x: { member_Id: any; }) => x.member_Id).join(',')
      let toMemberIdList: any[] = this.getMailIDList(toMemberIds);
      let ccMemberIdList: any[] = this.getMailIDList(ccMemberIds);
      let fromMemberIdList: any[] = this.getMailIDList(fromMemberIds);
      this.toMember = this.membersList.filter(f => toMemberIdList.some(item => item.memberId === f.memberId));
      this.ccMember = this.membersList.filter(f => ccMemberIdList.some(item => item.memberId === f.memberId));
      this.fromMember = this.membersList.filter(f => fromMemberIdList.some(item => item.memberId === f.memberId));
      let transmittalMsgInputDetails: ITransmittalMsgInputModel = {
        inputType: 'sendTransmittalMail',
        project_Id: this.projectId,
        message_Id: this.MessageId,
        message_Number: null,
        message_Serial_Number: null,
        discipline: null,
        parent_Message_Id: null,
        message_Type: 141,
        has_Attachments: false,
        is_Confidential: false,
        message_Category: 3,
        message_Subject: "",
        message_Body: "",
        response_Type: null,
        respond_On: null,
        issue_Reason: null,
        sent_On: null,
        is_Mail_Sent: is_Send_Mail,
        is_Active: true,
        userId: this.memberId
      };
      if (!!this.toMember && this.toMember.length>0) {
        await this._transmittalService.InsertUpdateTransmittalDetails(transmittalMsgInputDetails).subscribe(async (x: StandardOutputModel) => {
          if (x.successCode == 200 || x.successCode == 205) {
            let sTo: string = this.toMember?this.toMember.map(x => x.eMailId).join(','):"";
            let sCC: string = this.ccMember?this.ccMember.map(x => x.eMailId).join(','):"";
            let sFrom: string = this.fromMember?this.fromMember.map(x => x.eMailId).join(','):"";

            let filteredDTN: ITransmittalDetailsModel = this.gridData.filter(x => x.message_Id == this.MessageId)[0];
            let mailDetails: ITransmittalMailDetails = {
              from_List: sFrom,
              to_List: sTo,
              cc_List: sCC,
              project_Code: this.commonService.getProjectCode(),
              discipline: this.isNull(filteredDTN.discipline_Description),
              mail_Body: this.transmittalViewComponent.getHtmlContent(),
              mail_Subject: this._transmittalData ? this._transmittalData.subject : "",
              message_Id: this.MessageId
            }
            await this._transmittalService.SendTransmittalMail(mailDetails).subscribe((res: StandardOutputModel) => {
              if (res.successCode == 200 || res.successCode == 205) {
                this.notificationService.showToast("Transmittal Sent successfully", "Success");
                this.closeTabClick(this.viewTrasmittalTabs[0]);
              }
              else {
                this.notificationService.showToast(res.successMessage, "Warning");
              }
            });
          }
          else {
            this.notificationService.showToast(x.successMessage, "Warning");
          }
        });
      }
      else {
        this.notificationService.showPopup("To member is not in this Business Group", "Warning");
      }
    }
  }

  ngOnDestroy() {
    this.UnsubscribeArray.forEach(x => x.unsubscribe())
  }

  viewDci(transmittalDetails:ITransmittalDetailsModel)
  {
    const _dialog=this.dialog.open(TransmittalEditComponent,{
      panelClass: 'mat-dialog-primary',
      data: { inputType: 'dtnPreparation',transmittalId:transmittalDetails.message_Id},
    })
    _dialog.afterClosed().subscribe((res: any) => {
      this.loadGrid();
    });
  }
}
